import { Component, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from '../models/BaseBus';
import { GlobalsService } from '../services/globals.service';
import { UntypedFormGroup } from '@angular/forms';
import { DateFunctions } from '../static/date-functions';
import { BaseService } from '../services/base.service';
import { SaveMode } from '../enums/SaveMode';
import { BaseGridEditLineComponent } from './base-grid-editline.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: '',
    template: '',
    standalone: false
})
export class BaseGridEditAllLinesComponent<T extends BaseBus, D, S extends BaseService> extends BaseGridEditLineComponent<T, D, S>  {

    constructor(protected globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
    }
    protected _editing: boolean = false;
    get editing(): boolean {
        return this._editing;
    }
    @Input() set editing(value: boolean) {
        this._editing = value;
        this.edit(value);
    }
    public override cellClickHandler({ isEdited, dataItem, rowIndex, column }): void {
        this.editOn();
    }
    protected editOff() {
        let rows = this.gridData;
        if (CommonFunctions.hasArrayElementValue(rows)) {
            for (let i = 0; i < rows.length; i++) {
                this.grid.closeRow(i);
            }
        }
    }
    protected editOn() {
        this.setEditRows(0);
    }
    protected customSetEditRows(row: T): UntypedFormGroup {
        return null;
    }
    protected setEditRows(skip: number = 0) {

        let currentRow: number = skip;
        let rows = this.gridData;
        let form: UntypedFormGroup;
        if (CommonFunctions.hasArrayElementValue(rows)) {
            for (let i = 0; i < rows.length; i++) {
                form = this.customSetEditRows(rows[i] as T);
                this.grid.editRow(currentRow, form)
                currentRow++;
            }
        }
    }
    public edit(value: boolean) {
        if (value) {
            this.editOn();
        }
        else {
            this.editOff();
        }
    }
    public override addHandler(): void {
        //        this.closeEditor();
        let date: Date = DateFunctions.getDateNow();
        this.selectedData = this.createNew(null);
        this.selectedData.setNew(this.globals.userId, date, this.globals.companyId, this.globals.personId, this._parentId, this.locationDetail);
        if (this.saveMode === SaveMode.all && !CommonFunctions.hasGuidValue(this.selectedData.CID())) {
            this.selectedData.isAdded = true;
            this.selectedData.setId(CommonFunctions.getGuid());
        }

        this.afterAddNewData();
        if (!CommonFunctions.hasArrayValue(this.gridData)) {
            this.gridData = [];
        }
        this.gridData.push(this.selectedData);
        if (this.hasInvSvc) {
            this.showCpSearchDialog = true;
        }
        this.editOn();
    }
    protected override saveCurrent(dataItem: any = null): void {
        if (dataItem) {
            this.customPatchForm();
            let data: T = this.createNew();
            data.setFromForm(dataItem);
            data.setParentId(this._parentId);
            data.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
            if (data.usesOrderValue && !data.hasOrderValue) {
                let orderValue: number = this.getMaxOrderValue() + 1;
                data.orderValue = orderValue;
            }
            if (!data.isAdded) {
                data.isUpdated = true;
            }
            if (this.isNew) {
                data.isAdded = true;
            }
            if (this.saveMode === SaveMode.individual) {
                this.save(data);
            }
            else {
                if (this.isNew && !CommonFunctions.hasGuidValue(data.CID())) {
                    data.setId(CommonFunctions.getGuid());
                }
                this.customSaveLocal(data);
                this.saveLocal(data, this.isNew);
                this.isNew = false;
            }
            /************************************************************
             * Put in emit save method to update items on parent object
             ************************************************************/
        }
    }
}

